'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./page/product/productImgFancyBox'));
    processInclude(require('./page/product/productDetail'));
    processInclude(require('./page/product/detail'));
    processInclude(require('./page/product/productInfoTab'));
    processInclude(require('./page/product/productQtySelector'));
    processInclude(require('./components/sizeGuide'));
});
